<template>
  <el-upload
    :action="action"
    :show-file-list="true"
    :data="ossData"
    :on-success="onSuccess"
    :on-error="onError"
    :on-exceed="onExceed"
    :on-remove="onRemove"
    :before-upload="beforeUpload"
    :list-type="imgOnly ? 'picture-card' : 'text'"
    :file-list="imgOnly ? [] : value"
    :accept="imgOnly ? '.jpg,.png,.jpeg,.pdf' : '*'"
    :multiple="limit > 1"
    :limit="limit"
  >
    <i slot="default" class="el-icon-plus" v-if="imgOnly"></i>
    <el-button size="small" type="primary" v-else>点击上传</el-button>
  </el-upload>
</template>

<script>
import { getOssSignData } from '@/service/getData'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    imgOnly: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 9,
    },
  },
  data() {
    return {
      action: '',
      fileDir: '',
      ossData: {},
    }
  },
  created() {
    this.getOssData()
  },
  methods: {
    async getOssData() {
      let res = await getOssSignData()
      const data = res.data
      this.action = data.host
      this.fileDir = data.dir
      this.ossData = {
        key: data.dir,
        policy: data.policy,
        OSSAccessKeyId: data.access_key_id,
        success_action_status: '200',
        signature: data.signature,
      }
    },

    beforeUpload(file) {
      this.ossData.key += file.uid + '_' + file.name
    },

    onSuccess(response, file, fileList) {
      let res = fileList.map((item) => {
        if (!item.id) {
          item.path =
            this.action + '/' + this.fileDir + item.uid + '_' + item.name
        }

        if (this.imgOnly) {
          item = item.path
        }
        return item
      })

      this.$emit('input', res)
    },

    onError(err, file, fileList) {
      console.log(err)
    },

    onExceed(files, fileList) {
      this.$message.error(`最多只能上传${this.limit}个文件`)
    },

    onRemove(file, fileList) {
      let res = fileList.map((item) => {
        if (!item.id) {
          item.path =
            this.action + '/' + this.fileDir + item.uid + '_' + item.name
        }
        if (this.imgOnly) {
          item = item.path
        }
        return item
      })
      this.$emit('input', res)
    },
  },
}
</script>